import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.51201 12C4.74752 15.4964 8.08323 18 12 18C15.9177 18 19.2525 15.4965 20.488 12C19.2525 8.50354 15.9177 6 12 6C8.08323 6 4.74752 8.50359 3.51201 12ZM1.50394 11.7004C2.90509 7.23851 7.07378 4 12 4C16.9273 4 21.0949 7.23856 22.4961 11.7004C22.5573 11.8954 22.5573 12.1046 22.4961 12.2996C21.0949 16.7614 16.9273 20 12 20C7.07378 20 2.90509 16.7615 1.50394 12.2996C1.4427 12.1046 1.4427 11.8954 1.50394 11.7004ZM12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM9.17158 9.17157C9.92173 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92173 15.5786 9.17158 14.8284C8.42143 14.0783 8.00001 13.0609 8.00001 12C8.00001 10.9391 8.42143 9.92172 9.17158 9.17157Z"
    />
  </svg>
);

const EyeIcon = (props) => <Icon component={SVG} {...props} />;

export default EyeIcon;
